import { Button, Grid2, TextField } from "@mui/material";
import { SignalingConnection } from "../../api/signaling/SignalingConnection";
import { Robot } from "../../models/Robot";
import { useState } from "react";
import AceEditor from "react-ace";

const install_script_template = `#!/bin/bash
# pm_install.sh
# execute this script in your home directory
# this script installs ROBOCORE process manager
# create a new directory for the process manager
set -e
set -o pipefail
set -x
sudo systemctl stop robocorepm.service 2>/dev/null || true
sudo systemctl disable robocorepm.service 2>/dev/null || true
sudo rm -f /etc/systemd/system/robocorepm.service /lib/systemd/system/robocorepm.service
sudo systemctl daemon-reload
sudo curl -fsSL https://deb.nodesource.com/setup_{node_version}.x | sudo bash - && sudo apt-get install -y nodejs

sudo rm -rf techmage_home
mkdir -p techmage_home

cd techmage_home
mkdir -p robocorepm
curl -o pm.zip "{azure_blob_url}"
unzip pm.zip -d robocorepm

# switch to the process manager directory
cd robocorepm

# create a new .env file
TECHMAGE_HOME=$(dirname "$(pwd)")
echo "# ROBOCOREPM CONFIG" > .env
echo 'SIGNALING_URL="{signal_url}"' >> .env
echo "SIGNALING_GROUP={signal_group}" >> .env
echo "DEVICE_ID={device_id}" >> .env
echo 'DEVICE_TOKEN={device_token}' >> .env
echo 'BLOB_URL=\"{azure_blob_url}"' >> .env
echo "TECHMAGE_HOME=$TECHMAGE_HOME" >> .env
echo "NPM_LOCATION=$(which npm)" >> .env
echo "ETH0_IFACE=eth0" >> .env
echo "ETH0_IP=192.168.123.18" >> .env
echo "WIFI_IFACE=wlan0" >> .env
echo "AP_IP=10.42.0.1" >> .env
echo "AP_WIFI_SSID=TechMageAP" >> .env
echo "AP_WIFI_PASSWORD=TechMage123" >> .env
echo "ON_CONNECT_FAIL_START_AP=1" >> .env
echo "START_SIGNALING_LOCALLY=0" >> .env


# install dependencies
npm i
npm run build

# create a new systemd service file
echo "[Unit]" > robocorepm.service
echo "Description=RobocorePM Service" >> robocorepm.service
echo "After=network.target" >> robocorepm.service
echo "" >> robocorepm.service
echo "[Service]" >> robocorepm.service
echo "ExecStartPre=/bin/sleep {start_delay}" >> robocorepm.service
echo "ExecStart=$(which npm) start run" >> robocorepm.service
echo "WorkingDirectory=$(pwd)" >> robocorepm.service
echo "Restart=always" >> robocorepm.service
echo "" >> robocorepm.service
echo "[Install]" >> robocorepm.service
echo "WantedBy=multi-user.target" >> robocorepm.service
sudo mv robocorepm.service /etc/systemd/system/
sudo systemctl daemon-reload
sudo systemctl enable robocorepm.service
sudo systemctl start robocorepm.service
cd ..
`

interface InstallScriptParameters {
  startDelay: number;
  nodeVersion: string;
  package: string;
}

export function generateInstallScript(robot: Robot, params: InstallScriptParameters): string {
  // console.log("generateInstallScript for:", pmFileName);
  const signalingURL = process.env.REACT_APP_SIGNALING_URL;
  const signalingGroup = 'process-manager';
  let blobUrl = process.env.REACT_APP_BLOB_URL!;
  blobUrl = blobUrl.replace('?', `/${params.package}?`);
  // console.log(pmFileName, blobUrl);
  const deviceId = robot._id;
  const deviceToken = robot.token;
  let install_script = install_script_template;
  install_script = install_script.replace('{node_version}', params.nodeVersion);
  install_script = install_script.replace('{start_delay}', params.startDelay.toString());
  install_script = install_script.replace('{azure_blob_url}', blobUrl);
  install_script = install_script.replace('{signal_url}', signalingURL!);
  install_script = install_script.replace('{signal_group}', signalingGroup);
  install_script = install_script.replace('{device_id}', deviceId);
  install_script = install_script.replace('{device_token}', deviceToken);
  install_script = install_script.replace('{azure_blob_url}', process.env.REACT_APP_BLOB_URL!);
  return install_script;
}

export function InstallScript({ signaling, robot }:
  { signaling: SignalingConnection, robot: Robot }) {
  const [yamlContent, setYamlContent] = useState<string>("");
  const [editorMode, setEditorMode] = useState<string>("javascript");
  const [installScriptParameters, setInstallScriptParameters] = useState<InstallScriptParameters>({
    startDelay: 5,
    nodeVersion: "20",
    package: "pm_1.0.1.zip"
  });
  // console.log("RobotCodeManager", signaling, robot);
  return (
    <>
      <Grid2 container direction={'row'} sx={{ width: '100%', padding: '16px' }}>
        <TextField 
          label="Node Version" 
          variant="outlined" 
          value={installScriptParameters.nodeVersion}
          onChange={(e) => {
            setInstallScriptParameters({
              ...installScriptParameters,
              nodeVersion: e.target.value
            });
          }}
          size="small" 
          sx={{ marginRight: '20px' }} 
        />
        <TextField 
          label="Start Delay" 
          variant="outlined" 
          value={installScriptParameters.startDelay}
          onChange={(e) => {
            setInstallScriptParameters({
              ...installScriptParameters,
              startDelay: parseInt(e.target.value)
            });
          }}
          type="number"
          size="small" 
          sx={{ marginRight: '20px' }} 
        />
        <TextField 
          label="Robocore PM Package" 
          variant="outlined" 
          value={installScriptParameters.package}
          onChange={(e) => {
            setInstallScriptParameters({
              ...installScriptParameters,
              package: e.target.value
            });
          }}
          size="small" 
          sx={{ marginRight: '20px' }} 
        />        

        <Button variant="contained" onClick={async () => {
          setEditorMode("sh");
          const script = generateInstallScript(robot, installScriptParameters);
          setYamlContent(script);
        }} >Generate Install Script</Button>
      </Grid2>
      <AceEditor
        mode={editorMode}
        theme="twilight"
        name="yaml-editor"
        fontSize={25}
        width="100%"
        height="100%"
        value={yamlContent}
        onChange={setYamlContent}
        editorProps={{ $blockScrolling: true }}
        setOptions={{
          showLineNumbers: true,
          tabSize: 2,
        }}
      />
    </>
  )
}